<template>
  <regular-bar :config="config">
    <current-base-filter></current-base-filter>
  </regular-bar>
</template>

<script>
import CurrentBaseFilter from './CurrentBaseFilter'
import RegularBar from './Regular'

export default {
  components: { RegularBar, CurrentBaseFilter },
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
